import { useCallback, useRef } from "react";
import { unirComoRazonSocial, type NombreCliente } from "../utils/clientIdentityHelpers";

/**
 * Qué pasa con el nombre al cambiar entre Persona y Empresa.
 *
 * A empresa: los dos campos se unen en la razón social (el copiar/pegar queda
 * una sola vez). De vuelta a persona: se recupera lo escrito antes, siempre que
 * nadie haya tocado la razón social mientras tanto; un click equivocado no le
 * deja a una persona el nombre completo en un solo campo.
 *
 * Devuelve el nombre resultante; cada formulario lo guarda en su propio estado.
 */
export function useCambioTipoCliente() {
  const antesDeEmpresa = useRef<NombreCliente | null>(null);

  return useCallback((actual: NombreCliente, aEmpresa: boolean): NombreCliente => {
    if (aEmpresa) {
      antesDeEmpresa.current = actual;
      return unirComoRazonSocial(actual);
    }
    const previo = antesDeEmpresa.current;
    antesDeEmpresa.current = null;
    const sinTocar =
      previo !== null &&
      !actual.apellido.trim() &&
      unirComoRazonSocial(previo).nombre === actual.nombre.trim();
    return sinTocar ? previo : actual;
  }, []);
}
